<div class="ewb">

  <!-- ============ HEADER / CONTROLS ============ -->
  <header class="ewb-head">
    <div>
      <div class="ewb-eyebrow ei-mono">Editorial Workbench · research → guide → read → copy → paste back</div>
      <h1 class="ewb-title">Editorial state</h1>
    </div>
    <span class="ewb-pill info ei-mono">Dev2 · sold/live data read-only from prod</span>
  </header>

  <div class="ewb-controls">
    <input class="ewb-input ei-mono" [(ngModel)]="regInput" name="regInput"
           placeholder="any registration e.g. BEA5T" (keyup.enter)="researchPlate()" />
    <button class="ewb-btn primary" (click)="researchPlate()" [disabled]="researching || !!generating || !regInput">
      {{ researching ? 'Researching…' : 'Research this plate (live, paid)' }}
    </button>
    <button class="ewb-btn" (click)="inspect()" [disabled]="loading || researching">Inspect (read-only)</button>
    <span class="ewb-examples ei-mono">seeded:
      <button *ngFor="let e of examples" class="ewb-chip" (click)="pick(e)">{{ e }}</button>
    </span>
  </div>

  <!-- Stage progress for the full pipeline run -->
  <div class="ewb-stages" *ngIf="stages.length">
    <div class="ewb-stage" *ngFor="let s of stages" [ngClass]="s.status">
      <span class="ewb-stagedot"></span>
      <span class="ewb-stagelbl ei-mono">{{ s.label }}</span>
      <span class="ewb-stagest ei-mono">{{ s.status === 'active' ? '…' : (s.status === 'done' ? '✓' : (s.status === 'failed' ? '✕' : '')) }}</span>
    </div>
    <div class="ewb-genmsg ei-mono" *ngIf="researchMsg">{{ researchMsg }}</div>
  </div>

  <div class="ewb-note ei-mono">
    <b>Research</b> runs the full pipeline for any plate (verified sales pulled read-only from prod → web + media → pack → draft → audit).
    Inspecting is GET-only (no cost). Step-by-step controls below are for re-running a single stage after you guide the pack.
  </div>

  <div class="ewb-gen" *ngIf="reg">
    <button class="ewb-btn warn" (click)="generatePackBrief()" [disabled]="!!generating || researching">
      {{ generating === 'packbrief' ? 'Generating…' : 'Generate pack + brief' }}
    </button>
    <button class="ewb-btn warn" (click)="generateDraft()" [disabled]="!!generating || researching">
      {{ generating === 'draft' ? 'Generating…' : 'Generate draft' }}
    </button>
    <span class="ewb-genmsg ei-mono" *ngIf="genMessage">{{ genMessage }}</span>
    <span class="ewb-pill info ei-mono" *ngIf="packVersion != null">viewing pack v{{ packVersion }}</span>
  </div>

  <!-- Inject source (Human Injection, Type 2). Explicit, LIVE (it fetches). Guided
       natural-language is the primary path; manual claim-id is the fallback. On
       success it re-fetches via GET; the pack panes and version update. -->
  <div class="ewb-inject" *ngIf="reg && pack">
    <div class="ewb-cardh ei-mono">Inject source — live (fetches + reconciles into a NEW pack version)</div>
    <div class="ewb-injmode ei-mono">
      <label><input type="radio" name="injMode" [(ngModel)]="injMode" value="guided" /> Guided — write a note</label>
      <label><input type="radio" name="injMode" [(ngModel)]="injMode" value="manual" /> Manual — pick a claim id</label>
    </div>

    <!-- GUIDED (primary): brief it like a researcher. ONE LLM call routes the note to
         one of three handlers; you never pick the route — you just describe. -->
    <div *ngIf="injMode === 'guided'">
      <textarea class="ewb-input ei-mono ewb-injnote" rows="2" [(ngModel)]="injInstruction" name="injInstruction"
                placeholder="Brief it in plain English. Corroborate: “This article confirms Afzal Khan bought F1 — corroborate that” (+URL). Direct research: “Find out whether F1 ever appeared at a Goodwood auction.” Context note: “Owner is press-shy — keep quotes minimal.”"></textarea>
      <div class="ewb-injrow">
        <input class="ewb-input ei-mono ewb-injurl" [(ngModel)]="injUrl" name="injUrlG"
               placeholder="https://…  source URL (only used to corroborate a claim you reference)" />
        <input class="ewb-input ei-mono ewb-injconf" type="number" min="1" max="5"
               [(ngModel)]="injConfidence" name="injConfG" placeholder="conf 1–5" />
        <button class="ewb-btn warn" (click)="injectGuided()" [disabled]="injecting || !injInstruction">
          {{ injecting ? 'Working…' : 'Inject (guided)' }}
        </button>
      </div>
      <div class="ewb-injhint ei-mono">
        The interpreter picks the route: <b>corroborate</b> an existing claim · <b>direct research</b> into
        something new · file a <b>context note</b>. You describe; it decides.
      </div>
    </div>

    <!-- MANUAL (fallback): precise claim-id binding -->
    <div *ngIf="injMode === 'manual'" class="ewb-injrow">
      <input class="ewb-input ei-mono ewb-injurl" [(ngModel)]="injUrl" name="injUrlM"
             placeholder="https://…  a source URL that supports a claim" />
      <select class="ewb-input ei-mono" [(ngModel)]="injSupports" name="injSupports">
        <option value="">supports claim…</option>
        <option *ngFor="let c of claimOptions" [value]="c.id">{{ c.id }} [{{ c.status }}]</option>
      </select>
      <input class="ewb-input ei-mono ewb-injconf" type="number" min="1" max="5"
             [(ngModel)]="injConfidence" name="injConfM" placeholder="conf 1–5" />
      <button class="ewb-btn warn" (click)="injectSource()" [disabled]="injecting || !injUrl">
        {{ injecting ? 'Injecting…' : 'Inject source (live)' }}
      </button>
    </div>

    <div class="ewb-injresult" *ngIf="injMessage">
      <span class="ewb-pill info" *ngIf="lastRoute">{{ routeLabel(lastRoute) }}</span>
      <div class="ewb-genmsg ei-mono">{{ injMessage }}</div>
    </div>

    <!-- THE INVARIANT — identical across all three routes, stated in the UI. -->
    <div class="ewb-invariant ei-mono">
      <b>Invariant (every route):</b> your text never becomes a fact or a claim. Only fetched
      <b>sources</b> become evidence — entering at <i>unverified</i> and rising only by normal
      corroboration. Nothing reaches the writer on the strength of your words alone.
    </div>
    <ul class="ewb-safety ei-mono">
      <li><b>1 · Corroborate</b> — you reference a claim in the pack + give a URL → promoted only if the
          source genuinely supports it <b>and</b> is an independent domain. No/same-domain source → no promotion.</li>
      <li><b>2 · Direct research</b> — you describe something not in the pack → it becomes a research
          <i>direction</i>; the agent searches; only sourced results enter, at <i>unverified</i>. Nothing found → the direction just sits in the notebook.</li>
      <li><b>3 · Context note</b> — no URL, no research ask → filed in the notebook only, never evidence.</li>
      <li>editor_confidence is metadata only — it never touches status or the verifier.</li>
    </ul>
  </div>

  <div class="ewb-empty ei-mono" *ngIf="loading">Loading persisted state for {{ reg }}…</div>
  <div class="ewb-empty ei-mono" *ngIf="!reg && !loading">Enter a registration to inspect its editorial state.</div>

  <div class="ewb-grid" *ngIf="reg && !loading && state">

    <!-- 1. REGISTRATION SUMMARY -->
    <section class="ewb-card">
      <div class="ewb-cardh ei-mono">Registration summary</div>
      <ng-container *ngIf="dossier; else noDossier">
        <div class="ewb-kv"><b>Registration</b><span class="special-title">{{ dossier.formattedRegistration || reg }}</span></div>
        <div class="ewb-kv"><b>Status</b><span>{{ dossier.status || '—' }}</span></div>
        <div class="ewb-kv"><b>Story type</b><span>{{ dossier.storyType || '—' }}</span></div>
        <div class="ewb-kv"><b>Overall confidence</b><span>{{ dossier.overallConfidence ?? '—' }}</span></div>
        <div class="ewb-kv" *ngIf="dossier.decision"><b>Decision</b><span>{{ dossier.decision.decision || dossier.decision.recommendation || '—' }}</span></div>
        <div class="ewb-sub ei-mono">artifacts present:
          <span [class.on]="state.enrichedPack">pack</span> ·
          <span [class.on]="state.brief">brief</span> ·
          <span [class.on]="state.draft">draft</span> ·
          <span [class.on]="state.verification">verification</span>
        </div>
      </ng-container>
      <ng-template #noDossier><div class="ewb-none ei-mono">No dossier for this registration.</div></ng-template>
    </section>

    <!-- 2. ENRICHED PACK OVERVIEW -->
    <section class="ewb-card">
      <div class="ewb-cardh ei-mono">Enriched pack overview
        <span class="ewb-meta ei-mono">{{ meta(state.enrichedPack) }}</span></div>
      <ng-container *ngIf="pack; else notGen">
        <div class="ewb-kv"><b>Evidence items</b><span>{{ (pack.evidence || []).length }}</span></div>
        <div class="ewb-kv"><b>By type</b><span class="ei-mono">{{ pack.evidence_counts?.by_type | json }}</span></div>
        <div class="ewb-kv"><b>By status</b><span class="ei-mono">{{ pack.evidence_counts?.by_status | json }}</span></div>
        <div class="ewb-kv"><b>Rights summary</b>
          <span class="ewb-badges">
            <span class="ewb-pill ok">cleared {{ pack.rights_summary?.cleared || 0 }}</span>
            <span class="ewb-pill info">editorial {{ pack.rights_summary?.editorial_only || 0 }}</span>
            <span class="ewb-pill warn">needs perm {{ pack.rights_summary?.needs_permission || 0 }}</span>
            <span class="ewb-pill bad">blocked {{ pack.rights_summary?.blocked || 0 }}</span>
          </span>
        </div>
      </ng-container>
    </section>

    <!-- 4. RESEARCH / ENRICHMENT SUMMARY -->
    <section class="ewb-card">
      <div class="ewb-cardh ei-mono">Research / enrichment summary</div>
      <ng-container *ngIf="pack?.research as r; else notGen">
        <div class="ewb-kv"><b>Run</b><span class="ei-mono">searches {{ r.run_stats?.searches_run }} · pages {{ r.run_stats?.pages_fetched }} · kept {{ r.run_stats?.candidates_kept }} · discarded {{ r.run_stats?.candidates_discarded }} · media {{ r.run_stats?.media_leads }}</span></div>
        <div class="ewb-kv"><b>Stop</b><span class="ei-mono">{{ r.run_stats?.stop_reason }} · {{ r.run_stats?.wall_seconds }}s</span></div>
        <div class="ewb-cardh ei-mono" style="margin-top:10px">Coverage completeness</div>
        <div class="ewb-facet" *ngFor="let f of (r.completeness | keyvalue)">
          <span class="ewb-facetk ei-mono">{{ f.key }}</span>
          <span class="ewb-pill" [ngClass]="f.value.rating >= 3 ? 'ok' : (f.value.rating === 2 ? 'info' : (f.value.rating === 1 ? 'warn' : 'bad'))">
            {{ f.value.rating }}/3 {{ f.value.label }}</span>
          <span class="ewb-facethint ei-mono" *ngIf="f.value.missing">{{ f.value.missing }}</span>
        </div>
        <div class="ewb-cardh ei-mono" style="margin-top:10px" *ngIf="r.editor_surface?.interesting_discoveries?.length">Interesting discoveries</div>
        <div class="ewb-disc" *ngFor="let d of r.editor_surface?.interesting_discoveries">
          <span class="ewb-pill" [ngClass]="statusClass(d.status)">{{ d.status }}</span>
          {{ d.title }}
        </div>
      </ng-container>
    </section>

    <!-- 3. EVIDENCE ITEMS (canonical status + rights, from persisted pack) -->
    <section class="ewb-card ewb-wide">
      <div class="ewb-cardh ei-mono">Evidence items — status + canonical rights (from persisted pack)</div>
      <div class="ewb-none ei-mono" *ngIf="!pack">not yet generated</div>
      <div class="ewb-ev" [class.ewb-ev-injected]="isInjected(e)" *ngFor="let e of evidenceNonMedia">
        <div class="ewb-evtop">
          <span class="ewb-pill" [ngClass]="statusClass(e.status)">{{ e.status }}</span>
          <span class="ewb-pill ok ei-mono" *ngIf="justPromotedNow(e)">↑ just promoted</span>
          <span class="ewb-pill" [ngClass]="rightsClass(e.rights?.usage)">{{ e.rights?.usage }}</span>
          <span class="ewb-pill muted ei-mono">{{ e.type }}</span>
          <span class="ewb-pill info ei-mono" *ngIf="isInjected(e)">editor-injected</span>
          <span class="ewb-pill muted ei-mono" *ngIf="e.candidate && !isInjected(e)">agent-found</span>
          <span class="ewb-evsrc ei-mono">{{ e.source }}<span *ngIf="isInjected(e) && e.injected_by"> · by {{ e.injected_by }}</span></span>
        </div>
        <div class="ewb-evtext">{{ e.title || e.content }}</div>
        <div class="ewb-sub ei-mono" *ngIf="e.source_url">
          <a [href]="e.source_url" target="_blank" rel="noopener">source ↗</a>
        </div>
      </div>
    </section>

    <!-- 8. MEDIA CANDIDATES — visual thumbnail grid; rights badges stay prominent -->
    <section class="ewb-card ewb-wide">
      <div class="ewb-cardh ei-mono">Media candidates ({{ mediaItems.length }})
        <span class="ewb-meta ei-mono">rights badge decides what's publishable</span></div>

      <!-- Add media — paste a link OR upload/paste an image; you attribute it, it's cleared -->
      <div class="ewb-addmedia" *ngIf="pack" (paste)="onMediaPaste($event)">
        <div class="ewb-addhd ei-mono">Add media — paste a link or upload/paste an image (you assert rights → saved <b>cleared</b>)</div>
        <div class="ewb-addrow">
          <input class="ewb-input ei-mono ewb-addurl" [(ngModel)]="addUrl" name="addUrl"
                 [disabled]="!!addFile" placeholder="https://…  image or media URL" />
          <label class="ewb-btn ewb-addfilebtn">Choose image…
            <input type="file" accept="image/*,video/*" (change)="onMediaFileSelected($event)" hidden /></label>
          <span class="ewb-addhint ei-mono">…or paste an image anywhere in this panel</span>
        </div>
        <div class="ewb-addpreview" *ngIf="addPreview">
          <img [src]="addPreview" alt="to add" /><button class="ewb-chip" (click)="clearAddMedia()">clear</button>
        </div>
        <div class="ewb-addrow">
          <input class="ewb-input ei-mono" [(ngModel)]="addCredit" name="addCredit" placeholder="credit — name or @handle" />
          <input class="ewb-input ei-mono ewb-addurl" [(ngModel)]="addCreditUrl" name="addCreditUrl" placeholder="credit link (instagram / website)" />
        </div>
        <div class="ewb-addrow">
          <input class="ewb-input ei-mono ewb-addurl" [(ngModel)]="addCaption" name="addCaption" placeholder="caption / description (optional)" />
          <button class="ewb-btn warn" (click)="addMedia()" [disabled]="addingMedia || (!addUrl && !addFile)">
            {{ addingMedia ? 'Adding…' : 'Add media (cleared)' }}
          </button>
        </div>
        <div class="ewb-genmsg ei-mono" *ngIf="addMsg">{{ addMsg }}</div>
      </div>

      <div class="ewb-none ei-mono" *ngIf="!pack">not yet generated</div>
      <div class="ewb-none ei-mono" *ngIf="pack && !mediaItems.length">No media in pack yet — add one above, or research the plate.</div>
      <div class="ewb-mgrid" *ngIf="mediaItems.length">
        <div class="ewb-mcard" *ngFor="let m of mediaItems">
          <div class="ewb-mthumb">
            <img *ngIf="mediaThumb(m) && !brokenImg.has(m.id)" [src]="mediaThumb(m)"
                 [alt]="m.title || m.content" loading="lazy" referrerpolicy="no-referrer"
                 (error)="onMediaImgError(m.id)" />
            <div class="ewb-mph ei-mono" *ngIf="!mediaThumb(m) || brokenImg.has(m.id)">
              <span class="ewb-mphicon">{{ m.media_type === 'video' ? '▶' : '⊘' }}</span>
              <span>{{ m.media_type === 'video' ? 'video — no preview' : 'image unavailable' }}</span>
            </div>
            <span class="ewb-pill ewb-mrights" [ngClass]="rightsClass(m.rights?.usage)">{{ m.rights?.usage }}</span>
            <span class="ewb-pill info ewb-medited" *ngIf="m.origin === 'editor_added'">editor-added</span>
          </div>
          <div class="ewb-minfo">
            <div class="ewb-mmeta ei-mono">
              <span class="ewb-msource">{{ m.source }}</span>
              <span class="ewb-pill muted" *ngIf="m.media_type">{{ m.media_type }}</span>
              <span class="ewb-pill" [ngClass]="statusClass(m.status)">{{ m.status }}</span>
            </div>
            <div class="ewb-mcaption">{{ m.title || m.content }}</div>
            <div class="ewb-mcredit ei-mono" *ngIf="m.attribution">©
              <a *ngIf="m.attribution_url" [href]="m.attribution_url" target="_blank" rel="noopener noreferrer">{{ m.attribution }}</a>
              <span *ngIf="!m.attribution_url">{{ m.attribution }}</span>
            </div>
            <a class="ewb-msrc ei-mono" *ngIf="m.source_url && m.source_url.startsWith('http')"
               [href]="m.source_url" target="_blank" rel="noopener noreferrer">view source ↗</a>
          </div>
        </div>
      </div>
    </section>

    <!-- 5. EDITORIAL BRIEF -->
    <section class="ewb-card ewb-wide">
      <div class="ewb-cardh ei-mono">Editorial brief
        <span class="ewb-meta ei-mono">{{ meta(state.brief) }}</span></div>
      <ng-container *ngIf="brief; else notGen">
        <div class="ewb-kv"><b>Suggested type</b><span>{{ brief.suggested_article_type?.primary }}</span></div>
        <div class="ewb-kv"><b>Publishability</b><span class="ei-mono">{{ brief.publishability?.verdict }}</span></div>

        <div class="ewb-cardh ei-mono" style="margin-top:12px">Verified spine ({{ brief.verified_spine?.length || 0 }})</div>
        <div class="ewb-line" *ngFor="let s of brief.verified_spine">• {{ s.statement }}</div>

        <div class="ewb-cardh ei-mono" style="margin-top:12px">Candidate angles</div>
        <div class="ewb-angle" *ngFor="let a of brief.candidate_angles">
          <span class="ewb-pill" [ngClass]="a.strength === 'strong' ? 'ok' : (a.strength === 'promising' ? 'info' : 'muted')">{{ a.strength }}</span>
          <b>{{ a.label }}</b> <span class="ei-mono">({{ a.type }})</span>
          <div class="ewb-sub ei-mono">missing: {{ (a.missing_evidence || []).join('; ') }}</div>
        </div>

        <div class="ewb-cardh ei-mono" style="margin-top:12px" *ngIf="brief.conflicts?.length">Conflicts</div>
        <div class="ewb-line bad" *ngFor="let c of brief.conflicts">! [{{ c.kind }}] {{ c.detail }}</div>

        <div class="ewb-cardh ei-mono" style="margin-top:12px">Research priorities</div>
        <ol class="ewb-ol"><li *ngFor="let p of brief.recommended_research_priorities">{{ p }}</li></ol>
      </ng-container>
    </section>

    <!-- 6. DRAFT — read it, copy it out -->
    <section class="ewb-card ewb-wide">
      <div class="ewb-cardh ei-mono ewb-drafthd">
        <span>{{ draft?.editor_edited ? 'Draft — editor-finished (pasted back)' : 'Generated draft — readable structure' }}
          <span class="ewb-meta ei-mono">{{ meta(state.draft) }}</span></span>
        <span class="ewb-draftactions" *ngIf="draft">
          <span class="ewb-copymsg ei-mono" *ngIf="copyMsg">{{ copyMsg }}</span>
          <button class="ewb-btn" (click)="copyArticle()">Copy article ⧉</button>
        </span>
      </div>
      <ng-container *ngIf="draft; else notGen">
        <!-- editor-pasted final copy: render the markdown as-is -->
        <div class="ewb-draft" *ngIf="draft.editor_edited">
          <pre class="ewb-editedbody">{{ draft.body_markdown }}</pre>
        </div>
        <!-- generated structured draft -->
        <div class="ewb-draft" *ngIf="!draft.editor_edited">
          <h2 class="ewb-dh1">{{ draft.headline }}</h2>
          <p class="ewb-standfirst"><i>{{ draft.standfirst }}</i></p>
          <div class="ewb-section" *ngFor="let sec of draft.sections">
            <h3 class="ewb-dh2" *ngIf="sec.heading">{{ sec.heading }}</h3>
            <div class="ewb-block" *ngFor="let b of sec.blocks">
              <div [ngClass]="b.type === 'heading' ? 'ewb-dh3' : (b.type === 'pull_quote' ? 'ewb-pq' : 'ewb-p')">{{ b.text }}</div>
              <div class="ewb-blockmeta ei-mono" *ngIf="b.claim">
                <span class="ewb-pill" [ngClass]="statusClass(b.status_shown)">{{ b.status_shown }}</span>
                bound: {{ (b.evidence_refs || []).join(', ') }}
              </div>
            </div>
          </div>
          <div class="ewb-sub ei-mono" *ngIf="draft.seo">SEO: {{ draft.seo.seo_title || draft.seo.meta_title }} · slug {{ draft.seo.url_slug }}</div>
        </div>
      </ng-container>
    </section>

    <!-- 6b. PASTE BACK the improved version → saves as a new draft version -->
    <section class="ewb-card ewb-wide" *ngIf="reg">
      <div class="ewb-cardh ei-mono">Paste the finished / improved article back
        <span class="ewb-meta ei-mono">copy out → work it up in Claude/GPT → paste here → saves as a new version you can return to</span></div>
      <textarea class="ewb-input ei-mono ewb-pastebox" rows="10" [(ngModel)]="pasteText" name="pasteText"
                placeholder="Paste your worked-up article here (markdown). Saving keeps it as a new draft version; the pipeline draft stays in version history."></textarea>
      <div class="ewb-injrow">
        <button class="ewb-btn warn" (click)="savePastedDraft()" [disabled]="savingEdit || !pasteText">
          {{ savingEdit ? 'Saving…' : 'Save as new version' }}
        </button>
        <span class="ewb-genmsg ei-mono" *ngIf="editMsg">{{ editMsg }}</span>
      </div>
    </section>

    <!-- 7. VERIFICATION RESULT -->
    <section class="ewb-card">
      <div class="ewb-cardh ei-mono">Verification result
        <span class="ewb-meta ei-mono">{{ meta(state.verification) }}</span></div>
      <ng-container *ngIf="verification; else notGen">
        <div class="ewb-kv"><b>Hard checks</b>
          <span class="ewb-pill" [ngClass]="verification.passed ? 'ok' : 'bad'">{{ verification.passed ? 'PASS' : 'FAIL' }}</span></div>
        <div class="ewb-kv"><b>Verifier</b><span class="ei-mono">{{ verification.verifier }}</span></div>
        <div class="ewb-cardh ei-mono" style="margin-top:8px"
             *ngIf="(verification.hard_violations || verification.violations)?.length">Hard violations</div>
        <div class="ewb-line bad" *ngFor="let v of (verification.hard_violations || verification.violations)">- {{ v }}</div>
        <div class="ewb-kv" *ngIf="verification.advisory?.summary"><b>Attribution audit</b>
          <span class="warn">{{ verification.advisory.summary }}</span></div>
        <div class="ewb-caveat ei-mono">⚠ {{ verification.caveat }}</div>
      </ng-container>
    </section>

    <!-- 8b. COMPARABLE SALES — the actual comps the writer uses; eyeball for bad rows -->
    <section class="ewb-card ewb-wide">
      <div class="ewb-cardh ei-mono">Comparable sales ({{ comparables.length }})
        <span class="ewb-meta ei-mono" *ngIf="comparablesStats">
          range {{ money(comparablesStats.min) }}–{{ money(comparablesStats.max) }} · median {{ money(comparablesStats.median) }} · verified PlateX, last 5yr</span>
      </div>
      <div class="ewb-none ei-mono" *ngIf="!comparables.length">No comparable sales in the dossier.</div>
      <table class="ewb-table ei-mono" *ngIf="comparables.length">
        <tr><th>Registration</th><th>Sale price</th><th>Sale date</th><th>Venue</th></tr>
        <tr *ngFor="let c of comparables" [class.ewb-lowcomp]="isLowComp(c.price)">
          <td>{{ c.registration }}</td>
          <td>{{ money(c.price) }}<span *ngIf="isLowComp(c.price)" class="ewb-lowflag"> ⚠ low</span></td>
          <td>{{ c.soldDate || '—' }}</td>
          <td>{{ c.venue }}</td>
        </tr>
      </table>
      <div class="ewb-sub ei-mono" *ngIf="comparables.length">
        Sorted high→low. Rows flagged <b>⚠ low</b> (&lt; £10k) are likely historical/DVLA-assignment artifacts, not true cohort comparables — worth excluding at the source.
      </div>
    </section>

    <!-- 9. TIMELINE -->
    <section class="ewb-card">
      <div class="ewb-cardh ei-mono">Timeline</div>
      <div class="ewb-none ei-mono" *ngIf="!timeline.length">No timeline events.</div>
      <div class="ewb-tl" *ngFor="let t of timeline">
        <span class="ewb-tldate ei-mono">{{ t.date || t.event_date || '—' }}</span>
        <span class="ewb-tlev">{{ t.event }}</span>
        <span class="ewb-pill muted ei-mono" *ngIf="t.confidence != null">conf {{ t.confidence }}</span>
      </div>
    </section>

    <!-- 10. WARNINGS / CAVEATS -->
    <section class="ewb-card">
      <div class="ewb-cardh ei-mono">Warnings / caveats</div>
      <div class="ewb-none ei-mono" *ngIf="!warnings.length">None.</div>
      <div class="ewb-line warn" *ngFor="let w of warnings">• {{ w }}</div>
    </section>

    <!-- 10b. NOTEBOOK — editor notes & research directions. NEVER evidence. -->
    <section class="ewb-card ewb-wide">
      <div class="ewb-cardh ei-mono">
        Notebook — notes &amp; research directions ({{ notebook.length }})
        <span class="ewb-meta">not evidence · never reaches the writer as fact</span>
      </div>
      <div class="ewb-none ei-mono" *ngIf="!notebook.length">No notes yet. Guided notes that aren’t corroborations are filed here.</div>
      <div class="ewb-nb" *ngFor="let n of notebook">
        <span class="ewb-pill" [class.warn]="n.kind === 'direction'" [class.muted]="n.kind !== 'direction'">
          {{ n.kind === 'direction' ? 'research direction' : 'note' }}
        </span>
        <div class="ewb-nbbody">
          <div class="ewb-nbtext">{{ n.text }}</div>
          <div class="ewb-sub ei-mono">
            {{ n.author || 'editor' }} · {{ n.at | date:'d MMM HH:mm' }}
            <span *ngIf="n.queries?.length"> · searched: {{ n.queries.join(' | ') }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 11. ARTIFACTS / VERSION LIST -->
    <section class="ewb-card ewb-wide">
      <div class="ewb-cardh ei-mono">Artifacts / version history ({{ state.artifacts.length }})</div>
      <div class="ewb-none ei-mono" *ngIf="!state.artifacts.length">No persisted artifacts.</div>
      <table class="ewb-table ei-mono" *ngIf="state.artifacts.length">
        <tr><th>id</th><th>type</th><th>v</th><th>run</th><th>parent</th><th>model</th><th>passed</th><th>by</th><th>created</th></tr>
        <tr *ngFor="let a of state.artifacts">
          <td>{{ a.id }}</td><td>{{ a.artifact_type }}</td><td>{{ a.version }}</td>
          <td>{{ (a.pipeline_run_id || '').slice(0,8) }}</td><td>{{ a.parent_artifact_id ?? '—' }}</td>
          <td>{{ a.model || 'deterministic' }}</td><td>{{ a.passed == null ? '—' : a.passed }}</td>
          <td>{{ a.created_by }}</td><td>{{ a.created_at | date:'d MMM HH:mm' }}</td>
        </tr>
      </table>
    </section>

  </div>

  <ng-template #notGen><div class="ewb-none ei-mono">not yet generated</div></ng-template>
</div>
